export const isDateInThePast = (from, to) => Date.parse(from) < Date.parse(to)
